import React, { useMemo } from 'react';

import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import { styled } from "@material-ui/core/styles";

const StyledCommonButton = styled(Button)({
    boxShadow: 'none',
    fontSize: 14,
    textTransform: 'none',
    fontWeight: 600,
    border: '1px solid',
    backgroundColor: '#E66400',
    borderColor: '#E66400',
    paddingLeft: '28px',
    paddingRight: '28px',
    color: '#FFF',
    '&:hover': {
        backgroundColor: '#AC4B00',
        borderColor: '#AC4B00',
        boxShadow: 'none',
    },
    '&:active': {
        boxShadow: 'none',
        backgroundColor: '#AC4B00',
        borderColor: '#AC4B00',
    },
    '&:focus': {
        backgroundColor: '#AC4B00',
        borderColor: '#AC4B00',
    },
    '&.Mui-disabled': {
        color: '#CCCCCC',
        background: '#ECECEC',
        borderColor: '#ECECEC',
    },
    '& .MuiButton-label': {
        alignItems: 'center'
    }
});



const CommonButton = (props) => {

    const disabled = useMemo(() => {
        if (props.loading) return true;
        return props.disabled
        
    }, [props.loading, props.disabled])

    const startIcon = useMemo(() => {
        if (props.loading) return <CircularProgress size={18} color='inherit'/>
        return props.startIcon;
    }, [props.loading, props.startIcon]);
    
    return <StyledCommonButton {...props} loading={undefined} disabled={disabled} startIcon={startIcon}>
        {props.children}
    </StyledCommonButton>;
};

export default CommonButton;
